module.exports = __webpack_public_path__ + "img/brayden-law-1407613-unsplash.0073998d.jpg";